// @ts-nocheck — 디자인 원본 스크립트 포팅 (홈 HTML 하단 인라인 스크립트 + home-v3-fit.js)
import type { Scope } from './scope';

/** 마키(.mq) 항목을 화면 폭만큼 복제해서 끊김 없이 흐르게 함 */
export function initMarquee(root: ParentNode, s: Scope) {
  root.querySelectorAll('.mq .tr').forEach((tr) => {
    const orig = tr.innerHTML; // 페이지를 벗어날 때(또는 StrictMode 재실행) 원복
    const items = [...tr.children];
    const half = items.slice(0, items.length / 2);
    tr.innerHTML = '';
    const set = () => half.forEach((n) => tr.appendChild(n.cloneNode(true)));
    set();
    let w = 0;
    while (tr.scrollWidth < innerWidth * 1.2 && w < 6) {
      set();
      w++;
    }
    const one = tr.innerHTML;
    tr.innerHTML = one + one;
    s.onDispose(() => {
      tr.innerHTML = orig;
    });
  });
}

/** 벤토 카드 안의 목업(.ill) 높이/우측 여백을 내용에 맞춰 보정 (원본 home-v3-fit.js) */
export function initCardFit(root: ParentNode, s: Scope) {
  const { setTimeout, addEventListener } = s;
  const B = 24;
  const reset = (c) => {
    if (c.dataset.fx) {
      c.style.marginRight = c.dataset.mr;
      c.style.paddingRight = c.dataset.pr;
      c.style.paddingBottom = c.dataset.pb;
      delete c.dataset.fx;
    }
  };
  const ext = (c, side) => {
    if (!c.dataset.fx) {
      c.dataset.fx = 1;
      c.dataset.mr = c.style.marginRight;
      c.dataset.pr = c.style.paddingRight;
      c.dataset.pb = c.style.paddingBottom;
    }
    const cs = getComputedStyle(c);
    if (side === 'r') {
      c.style.marginRight = -B + 'px';
      c.style.paddingRight = parseFloat(cs.paddingRight) + B + 'px';
    } else {
      c.style.paddingBottom = parseFloat(cs.paddingBottom) + B + 'px';
    }
  };
  const fit = () =>
    root.querySelectorAll('.bc .ill').forEach((ill) => {
      if (ill.closest('.pc,.tall,.stx') || ill.classList.contains('nc') || ill.classList.contains('fit3')) return;
      const kids = [...ill.children].filter((c) => !(c.tagName === 'svg' && !c.getAttribute('style')) && !c.classList.contains('cursor'));
      kids.forEach(reset);
      if (kids.some((c) => /(^|;)\s*bottom:/.test(c.getAttribute('style') || ''))) return;
      ill.style.height = '0px';
      let m = 0;
      kids.forEach((c) => {
        const b = c.offsetTop + c.offsetHeight;
        if (b > m) m = b;
      });
      ill.style.height = m + 'px';
      const W = ill.clientWidth,
        card = ill.closest('.bc');
      kids.forEach((c) => {
        if (c.classList.contains('ui') && !c.classList.contains('hl') && c.offsetHeight > 90 && c.offsetLeft + c.offsetWidth >= W - 1) ext(c, 'r');
      });
      card.style.paddingBottom = '30px';
    });
  addEventListener('load', fit);
  addEventListener('resize', fit);
  setTimeout(fit, 300);
  setTimeout(fit, 1200);
  if (document.fonts) document.fonts.ready.then(fit);
}

/** 모자이크 카드(.mos)의 요소들을 순서대로 등장시키는 반복 애니메이션 */
export function initMosaic(root: ParentNode, s: Scope) {
  const { setTimeout } = s;
  const mos = root.querySelector('.mos');
  if (!mos) return;
  const cards = [].slice.call(root.querySelectorAll('.mos>.bc')).slice(1);
  const Q = (c, sel) => [].slice.call(c.querySelectorAll(sel));
  const seqs = cards.map((c) => {
    let l;
    if (c.querySelector('.qr')) {
      const u = c.querySelector('.ui');
      l = [u.querySelector('.uih'), u.querySelector('.uih').nextElementSibling].concat(Q(c, '.qr span'));
    } else if (c.querySelector('.tbl')) {
      l = [c.querySelector('.ask'), c.querySelector('.ui .uih')].concat(Q(c, '.bar'));
    } else if (c.querySelector('.mflow')) {
      l = [].slice.call(c.querySelector('.mflow').children).concat(Q(c, '.log .r2'));
    } else l = [];
    l = l.filter(Boolean);
    l.forEach((e) => e.classList.add('an'));
    return l;
  });
  function run(l) {
    const st = l.length > 5 ? 160 : 300;
    let t = 0;
    l.forEach((e) => {
      setTimeout(() => e.classList.add('on'), (t += st));
    });
    setTimeout(() => {
      l.forEach((e) => e.classList.remove('on'));
      setTimeout(() => run(l), 400);
    }, t + 2200);
  }
  const io = new IntersectionObserver(
    (es) => {
      if (es.some((en) => en.isIntersecting)) {
        io.disconnect();
        seqs.forEach(run);
      }
    },
    { threshold: 0.15 },
  );
  io.observe(mos);
  s.onDispose(() => io.disconnect());
}
